import { Box, Button, FormControlLabel, Stack, Typography } from "@mui/material"
import { useContext, useState } from "react"
import { CheckoutContext } from "../../../../core/contexts/CheckoutContext"
import BpCheckbox from "../../../Inputs/BpCheckbox"
import HttpsIcon from "@mui/icons-material/Https"
import { useTranslation } from "react-i18next"

const CheckoutButtonCommit7 = () => {
  const { sendingPurchase, isPurposeCardUpdate } = useContext(CheckoutContext)
  const [saveInfo, setSaveInfo] = useState(true)
  const { t } = useTranslation()

  const textButton = isPurposeCardUpdate()
    ? t("checkout.v7.button.updateCard")
    : t("checkout.v7.button.finish")

  return (
    <Stack
      direction={"column"}
      alignContent={"center"}
      alignItems={"center"}
      sx={{ width: "100%", pt: 0 }}
    >
      <Button
        fullWidth
        disableElevation
        id="buttonCommit"
        type="submit"
        variant="contained"
        disabled={sendingPurchase}
        style={{
          height: 70,
          textTransform: "none",
          border: "0px solid black",
          borderRadius: "50px",
          color: "white",
          backgroundColor: sendingPurchase ? "#85868A" : "#3ebf90",
        }}
        //sx={{ fontWeight: 700, fontSize: "22px", lineHeight: "32px" }}
        data-testid="buttonCommit"
        startIcon={<HttpsIcon />}
      >
        <Typography fontWeight={500} fontSize="22px" lineHeight="28px">
          {textButton}
        </Typography>
      </Button>

      {/*<Box sx={{ marginTop: 3, marginBottom: 1 }}>
        <img
          src="/assets/layouts/v6/logo-celetus-grey-footer.svg"
          alt="celetus"
        />
      </Box>*/}
    </Stack>
  )
}

export default CheckoutButtonCommit7
